module.exports = __webpack_public_path__ + "img/netshoes-cover.343ed5ac.jpg";